export enum DeductFrom {
    ACCOUNT = 'A',
    PAYMENT = 'P'
}